import { PageHeader } from "../components/PageHeader";
import { CTASection } from "../components/CTASection";
import { Reveal } from "../components/Reveal";
import { IMPACT_AREAS, IMAGES } from "../data/content";
import { CheckCircle2, Users, School, HandHeart, Building2 } from "lucide-react";

const APPROACH = [
  { icon: Users, title: "Community First", text: "Every program begins by listening to the community and understanding its real needs." },
  { icon: HandHeart, title: "Volunteer Driven", text: "Doctors, nurses, teachers and local volunteers power our camps and campaigns." },
  { icon: School, title: "Institutional Partnerships", text: "We work with schools, health departments and hospitals to extend our reach." },
  { icon: Building2, title: "Transparent Operations", text: "Programs are documented, reported and shared with donors and partners." },
];

export default function OurWork() {
  return (
    <main data-testid="our-work-page">
      <PageHeader
        title="Our Work"
        subtitle="Four focus areas, one goal — healthier, stronger communities across Assam."
      />

      <section className="py-16 sm:py-20 bg-white">
        <div className="container-hecso space-y-16">
          {IMPACT_AREAS.map((area, i) => (
            <Reveal key={area.title}>
              <div className={`grid lg:grid-cols-2 gap-10 items-center ${i % 2 === 1 ? "lg:[&>*:first-child]:order-2" : ""}`} data-testid={`work-area-${i}`}>
                <img src={area.image} alt={area.title} className="rounded-2xl w-full h-[340px] object-cover shadow-md" />
                <div>
                  <span className="text-xs font-semibold uppercase tracking-widest text-hecso-orange">Focus Area {String(i + 1).padStart(2, "0")}</span>
                  <h2 className="mt-3 text-2xl sm:text-3xl font-semibold tracking-tight text-hecso-ink">{area.title}</h2>
                  <p className="mt-4 text-sm sm:text-base text-hecso-muted leading-relaxed">{area.description}</p>
                  <ul className="mt-5 space-y-3">
                    {area.points.map((pt, j) => (
                      <li key={j} className="flex gap-3 text-sm text-hecso-muted">
                        <CheckCircle2 className="w-5 h-5 shrink-0 text-hecso-green" /> {pt}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      <section className="py-16 sm:py-20 bg-hecso-beige" data-testid="approach-section">
        <div className="container-hecso">
          <Reveal className="max-w-3xl mx-auto text-center mb-12">
            <span className="text-xs font-semibold uppercase tracking-widest text-hecso-orange">How We Work</span>
            <h2 className="mt-3 text-2xl sm:text-3xl font-semibold tracking-tight text-hecso-ink">Our Approach</h2>
          </Reveal>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            {APPROACH.map((a, i) => (
              <Reveal key={a.title} delay={i * 100}>
                <div className="h-full rounded-xl border border-slate-200 bg-white p-6 shadow-sm text-center" data-testid={`approach-card-${i}`}>
                  <span className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-hecso-greensubtle text-hecso-green">
                    <a.icon className="w-6 h-6" />
                  </span>
                  <h3 className="mt-4 font-heading text-base font-semibold text-hecso-ink">{a.title}</h3>
                  <p className="mt-2 text-sm text-hecso-muted leading-relaxed">{a.text}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="py-16 bg-white">
        <div className="container-hecso grid lg:grid-cols-2 gap-10 items-center">
          <Reveal>
            <img src={IMAGES.gramSabha} alt="Community participation in Assam" className="rounded-2xl w-full h-[320px] object-cover shadow-md" />
          </Reveal>
          <Reveal delay={150}>
            <h2 className="text-2xl sm:text-3xl font-semibold tracking-tight text-hecso-ink">Working Together With Assam</h2>
            <p className="mt-4 text-sm sm:text-base text-hecso-muted leading-relaxed">
              HECSO collaborates with government health departments, district administrations, schools, eye
              hospitals, local clubs and 25+ partner organizations to deliver programs where they are needed
              most. This partnership model keeps our work rooted, accountable and sustainable.
            </p>
          </Reveal>
        </div>
      </section>

      <CTASection />
    </main>
  );
}
